const Service = {
  getLayersData: contentId => window.FUN_LINK_SDK.getLayersData([{ layerId: 'content', type: 'content', param: { contentId } }])
};
export default Service;
